module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Rose Gold + Black Leather Closed.5ca143de.png";